/* T-MOD virtual Variant positions: canonical Shopify Variant owns checkout and inventory. */
(() => {
  const registryNode = document.getElementById('TmodVirtualVariantPositionRegistry');
  let positions = [];
  try { positions = JSON.parse(registryNode?.textContent || '{"positions":[]}').positions || []; } catch (_) { return; }
  const path = window.location.pathname.replace(/\/$/, '');
  const paramName = 'tmod-virtual-position';
  const activeRequests = new WeakMap();
  const galleryRestoreHtml = new WeakMap();
  const currentPosition = (id) => {
    const raw = positions.find((entry) => String(entry?.id) === String(id));
    if (!raw) return null;
    const input = virtualInput(document.querySelector('product-info'), id);
    const mode = input?.dataset?.tmodVirtualMode || raw.mode || 'virtual-position';
    const fitmentLabel = input?.dataset?.tmodFitmentLabel || raw.fitmentLabel || '';
    const label = raw.label || input?.value || 'Option';
    return { ...raw, mode, fitmentLabel, label };
  };
  const parentMatches = (position) => path === ('/products/' + String(position?.parentProductHandle || '').replace(/^\/+/, ''));
  const positionFor = (target) => currentPosition(target?.dataset?.tmodPositionId);
  const infoFor = (target) => target?.closest?.('product-info') || document.querySelector('product-info');
  const virtualInput = (productInfo, id) => Array.from(productInfo?.querySelectorAll?.('[data-tmod-position-id]') || []).find((input) => String(input.dataset.tmodPositionId) === String(id));
  const formFor = (productInfo) => productInfo?.querySelector?.('product-form form');
  const setStatus = (productInfo, message) => {
    if (!productInfo) return;
    let status = productInfo.querySelector('[data-tmod-embedded-status]');
    if (!status) {
      status = document.createElement('span');
      status.dataset.tmodEmbeddedStatus = 'true';
      status.className = 'visually-hidden';
      status.setAttribute('aria-live', 'polite');
      productInfo.querySelector('variant-selects')?.append(status);
    }
    status.textContent = message || '';
  };
  const setSubmit = (productInfo, disabled, text) => {
    const productForm = productInfo?.querySelector?.('product-form');
    if (typeof productForm?.toggleSubmitButton === 'function') productForm.toggleSubmitButton(disabled, text);
  };
  const setAcceleratedCheckout = (productInfo, hidden) => {
    productInfo?.querySelectorAll?.('[data-shopify="payment-button"]').forEach((element) => {
      element.hidden = hidden;
      element.setAttribute('aria-hidden', String(hidden));
    });
  };
  const removeFitmentProperty = (productInfo) => productInfo?.querySelectorAll?.('[data-tmod-embedded-fitment-property]').forEach((input) => input.remove());
  const setFitmentProperty = (productInfo, value) => {
    const form = formFor(productInfo);
    if (!form || !value) return;
    let input = form.querySelector('[data-tmod-embedded-fitment-property]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'properties[Vehicle Fitment]';
      input.dataset.tmodEmbeddedFitmentProperty = 'true';
      form.append(input);
    }
    input.value = value;
  };
  const setCanonicalId = (productInfo, id) => productInfo?.querySelectorAll?.('form input[name="id"]').forEach((input) => {
    input.value = id;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
  const setVirtualUrl = (position) => {
    const url = new URL(window.location.href);
    url.searchParams.delete('variant');
    url.searchParams.set(paramName, position.id);
    window.history.replaceState({}, '', url.pathname + url.search + url.hash);
  };
  const restoreGallery = (productInfo) => {
    const original = galleryRestoreHtml.get(productInfo);
    if (!original) return;
    const current = productInfo.querySelector('media-gallery');
    if (current) {
      const template = document.createElement('template');
      template.innerHTML = original.trim();
      const restored = template.content.querySelector('media-gallery');
      if (restored) current.replaceWith(restored);
    }
    galleryRestoreHtml.delete(productInfo);
  };
  const syncGallery = (productInfo, state, position) => {
    if (position?.displayMediaId) {
      const gallery = productInfo.querySelector('media-gallery');
      const targetId = productInfo.dataset.section + '-' + String(position.displayMediaId).split('/').pop();
      const media = Array.from(gallery?.querySelectorAll('[data-media-id]') || []).find((node) => node.dataset.mediaId === targetId);
      if (!media || typeof gallery?.setActiveMedia !== 'function') throw new Error('Selected style image is unavailable');
      gallery.setActiveMedia(targetId, true);
      return;
    }
    if (!state.galleryHtml) return;
    const current = productInfo.querySelector('media-gallery');
    if (!current) return;
    if (!galleryRestoreHtml.has(productInfo)) galleryRestoreHtml.set(productInfo, current.outerHTML);
    const template = document.createElement('template');
    template.innerHTML = state.galleryHtml.trim();
    const replacement = template.content.querySelector('media-gallery');
    if (replacement) current.replaceWith(replacement);
  };
  const clearEmbedded = (productInfo) => {
    if (!productInfo?.dataset?.tmodEmbeddedPosition) return;
    activeRequests.delete(productInfo);
    restoreGallery(productInfo);
    delete productInfo.dataset.tmodEmbeddedPosition;
    removeFitmentProperty(productInfo);
    setAcceleratedCheckout(productInfo, false);
    productInfo.querySelectorAll('[data-tmod-position-id]').forEach((input) => { input.checked = false; });
    setStatus(productInfo, '');
  };
  const canonicalState = async (position, productInfo) => {
    const sectionId = productInfo?.dataset?.section;
    if (!sectionId) throw new Error('Product section is unavailable');
    const url = '/products/' + encodeURIComponent(position.canonicalProductHandle) + '?variant=' + encodeURIComponent(position.canonicalVariantId) + '&section_id=' + encodeURIComponent(sectionId);
    const response = await fetch(url, { credentials: 'same-origin' });
    if (!response.ok) throw new Error('Shared inventory option could not be loaded');
    const html = new DOMParser().parseFromString(await response.text(), 'text/html');
    const selected = html.querySelector('variant-selects [data-selected-variant]')?.textContent;
    const variant = selected ? JSON.parse(selected) : null;
    const price = html.getElementById('price-' + sectionId);
    if (!variant || !price || String(variant.id) !== String(position.canonicalVariantId)) throw new Error('Shared inventory option did not resolve to the expected Variant');
    const galleryHtml = html.querySelector('media-gallery')?.outerHTML || '';
    return { variant, price, galleryHtml };
  };
  const applyCanonicalState = (position, productInfo, state) => {
    syncGallery(productInfo, state, position);
    const price = productInfo.querySelector('#price-' + productInfo.dataset.section);
    if (price) price.innerHTML = state.price.innerHTML;
    setCanonicalId(productInfo, position.canonicalVariantId);
    setFitmentProperty(productInfo, position.fitmentLabel);
    setAcceleratedCheckout(productInfo, true);
    setSubmit(productInfo, !state.variant.available, state.variant.available ? window.variantStrings?.addToCart : window.variantStrings?.soldOut);
    const pickup = productInfo.querySelector('pickup-availability');
    if (pickup) pickup.hidden = true;
  };
  const selectEmbedded = async (position, target) => {
    const productInfo = infoFor(target);
    const input = virtualInput(productInfo, position.id);
    if (!productInfo || !input || !position.canonicalVariantId || !position.canonicalProductHandle || !position.fitmentLabel) return;
    const request = Symbol(position.id);
    activeRequests.set(productInfo, request);
    productInfo.dataset.tmodEmbeddedPosition = position.id;
    productInfo.querySelectorAll('variant-selects input:not([data-tmod-position-id])').forEach((nativeInput) => { nativeInput.checked = false; });
    productInfo.querySelectorAll('[data-tmod-position-id]').forEach((virtual) => { virtual.checked = virtual === input; });
    setSubmit(productInfo, true, 'Loading…');
    setAcceleratedCheckout(productInfo, true);
    const label = position.label || 'Option';
    setStatus(productInfo, 'Loading ' + label + ' for ' + position.fitmentLabel + '.');
    setVirtualUrl(position);
    try {
      const state = await canonicalState(position, productInfo);
      if (activeRequests.get(productInfo) !== request || productInfo.dataset.tmodEmbeddedPosition !== position.id) return;
      applyCanonicalState(position, productInfo, state);
      setStatus(productInfo, label + ' selected. Verified fit for ' + position.fitmentLabel + '.');
    } catch (error) {
      if (activeRequests.get(productInfo) !== request) return;
      setSubmit(productInfo, true, window.variantStrings?.unavailable || 'Unavailable');
      setStatus(productInfo, error?.message || 'Shared inventory option could not be loaded.');
    }
  };
  const navigate = (target) => {
    const href = target?.dataset?.tmodCanonicalUrl;
    if (href) window.location.assign(href);
  };
  const legacy = new URLSearchParams(window.location.search).get('variant');
  const storedId = new URLSearchParams(window.location.search).get(paramName);
  const resolvedPositions = positions.map((position) => currentPosition(position.id)).filter(Boolean);
  const initial = resolvedPositions.find((position) => parentMatches(position) && position.mode === 'embedded-canonical' && (String(position.id) === String(storedId || '') || String(position.retiredVariantId) === String(legacy || '')));
  const defaultPosition = !legacy && !storedId
    ? resolvedPositions.find((position) => String(position.id) === 'juniper-rwd-floor-mat-3pcs' && parentMatches(position) && position.mode === 'embedded-canonical')
    : null;
  if (initial) selectEmbedded(initial, virtualInput(document.querySelector('product-info'), initial.id));
  else if (defaultPosition) selectEmbedded(defaultPosition, virtualInput(document.querySelector('product-info'), defaultPosition.id));
  else {
    const retired = resolvedPositions.find((position) => parentMatches(position) && String(position.retiredVariantId) === String(legacy || ''));
    if (retired?.canonicalProductHandle && retired?.canonicalVariantId) {
      window.location.replace('/products/' + retired.canonicalProductHandle + '?variant=' + retired.canonicalVariantId);
      return;
    }
  }
  document.addEventListener('click', (event) => {
    const target = event.target?.closest?.('[data-tmod-virtual-position]');
    if (!target) return;
    const position = positionFor(target);
    if (!target.matches('input[type="radio"]')) event.preventDefault();
    event.stopImmediatePropagation(); event.stopPropagation();
    if (position?.mode === 'embedded-canonical') selectEmbedded(position, target); else navigate(target);
  }, true);
  document.addEventListener('change', (event) => {
    const target = event.target;
    const virtualTarget = target?.closest?.('[data-tmod-virtual-position]');
    if (virtualTarget) {
      const position = positionFor(virtualTarget);
      event.preventDefault(); event.stopImmediatePropagation(); event.stopPropagation();
      if (position?.mode === 'embedded-canonical') selectEmbedded(position, virtualTarget); else navigate(virtualTarget);
      return;
    }
    if (target?.matches?.('variant-selects input, variant-selects select')) clearEmbedded(infoFor(target));
  }, true);
})();
